import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const FolderIcon = createIcon({
  displayName: 'FolderIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g xmlns="http://www.w3.org/2000/svg" fill="none">
        <path d="M0,0h24v24h-24v-24Z" />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M19,10v-1c0,-1.105 -0.895,-2 -2,-2h-4.465c-0.334,0 -0.647,-0.167 -0.832,-0.445l-1.406,-2.109c-0.186,-0.279 -0.498,-0.446 -0.832,-0.446h-4.465c-1.105,0 -2,0.895 -2,2v12.853c0,0.634 0.513,1.147 1.147,1.147v0c0.506,0 0.953,-0.332 1.098,-0.817l2.327,-7.757c0.254,-0.847 1.033,-1.426 1.916,-1.426h9.841c1.335,0 2.295,1.282 1.919,2.563l-1.761,6c-0.25,0.852 -1.031,1.437 -1.919,1.437h-13.421"
        />
      </g>
    </>
  ),
})

const Folder: FC<IconProps> = (props) => {
  return <CustomIcon as={FolderIcon} {...props} />
}

export default memo(Folder)
